import { useConnectModal } from "@rainbow-me/rainbowkit";
import { useState } from "react";
import { useAccount } from "wagmi";

const NFT = () => {
    const [selectedNFT, setSelectedNFT] = useState('TinyBlock NFT');
    const { address }: any = useAccount();
    const { openConnectModal }= useConnectModal();
    //TODO: Replace these dummy with integrated API;
    const imgURL1 = "https://chaingpt-launchpad.s3.us-east-2.amazonaws.com/images/ido/ChainAware.ai209web3-ai-agents-graph.jpg";
    const imgURL2 = "https://chaingpt-launchpad.s3.us-east-2.amazonaws.com/images/ido/Klink-Finance293Cover%20Image%20.png";
    const creator = "TinyBlock";
    const mintTime = "ENDED";
    const totalSupply = 1000;
    const totalMinted = 0;

    return (<div className="py-28 xl:py-[150px] px-5 md:px-8 xl:px-14 flex items-center justify-center">
        <div className="bg-backgroundWhite w-full p-3 shadow-[0px_8px_16px_0px_rgba(0,148,255,0.3)] rounded-2xl">
            <div className="flex flex-col space-y-3">
                <div className="flex flex-row h-10 border-b-[1px] justify-center text-lg pt-2">
                    <div
                    onClick={() => setSelectedNFT('TinyBlock NFT')} 
                    className={`${selectedNFT === 'TinyBlock NFT' 
                        ? "font-bold text-customBlue-500 text-xl border-b-4 border-customBlue-500" 
                        : "text-text-secondary"} me-9 duration-300 font-semibold cursor-pointer`}>
                        TinyBlock NFT
                    </div>
                    <div 
                    onClick={() => setSelectedNFT('My NFT')}
                    className={`${selectedNFT === 'My NFT' 
                        ? "font-bold text-customBlue-500 text-xl border-b-4 border-customBlue-500" 
                        : "text-text-secondary"} me-5 duration-300 font-semibold cursor-pointer`}>
                        My NFT
                    </div>
                </div>

                <div className="flex flex-col xl:flex-row items-start space-y-3 xl:space-x-6">
                <div className="flex w-full justify-center items-center xl:mt-5">
                <img alt='tiny-block-nft-img'
                    className="max-h-44 xl:max-h-64" 
                    src={`${selectedNFT === 'TinyBlock NFT' 
                    ? imgURL1 
                    : imgURL2}`}/>
                </div>

                <div className="flex flex-col space-y-3 xl:space-y-4 items-start text-text-secondary">
                    <p className="font-semibold text-xl xl:text-3xl">{selectedNFT}</p>
                    {/* TODO: Replace this placeholder with production text description */}
                    <p className="text-start xl:text-lg">{selectedNFT === 'TinyBlock NFT' ? "Get a piece of our exclusive NFTs: OG, Early Bird, and Placeholder.... Enjoy unique perks like early access to new features, special events, and exclusive merchandise. Show your support and be recognized as a key member of our community!" : "Our NFT is proof of your deep engagement and support within the community, awarded to winners of our competition. Your efforts have earned you a special place in our ecosystem, recognizing you as a key contributor to our growth and future."}</p>
                    
                    <p className="xl:text-lg">Creator: <span className="font-medium">{creator}</span></p>

                    <div className="bg-customBlue-200 w-full flex flex-col xl:flex-row space-y-3 rounded-xl xl:justify-around xl:space-y-0 p-3 text-start">
                        <div>
                            <p>Mint Time</p>
                            <p className="font-semibold text-lg">{mintTime}</p>
                        </div>

                        <div>
                            <p>Total Supply</p>
                            <p className="font-semibold text-lg">{totalSupply}</p>
                        </div>

                        <div>
                            <p>Total Minted</p>
                            <p className="font-semibold text-lg">{totalMinted} NFTs</p>
                        </div>
                    </div>
                    <div className="w-full flex justify-center xl:justify-start">
                        <button
                        className="main-button w-200"
                        onClick={openConnectModal}
                        >
                        {address 
                        ? `${address?.substring(0, 4)}...
                        ${address?.substring(address.length - 4)}` 
                        : "Connect Wallet"}
                        </button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>)
}

export default NFT;